<template>
  <aside v-if="token" id="sidenav-main" style="z-index: 1050" class="sidenav navbar navbar-vertical navbar-expand-xs border-0" :class="`${
      isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start'
    } ${sidebarType} ${isCollapsed ? 'collapsed' : ''}`">
    <div class="sidenav-header d-flex px-0 py-2" style="height: 56px;">
      <i class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true" id="iconSidenav"></i>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="justify-content-center text-center logo-text" :class="isCollapsed ? 'ms-2' : 'ms-5'">
          MINTY
        </div>
        <div class="me-1" :class="isCollapsed ? 'mt-1' : 'mt-0'">
          <i v-if="isCollapsed" class="fa fa-bars icon-close-sidenav-main cursor-pointer p-3" aria-hidden="true" @click="toggleSidebar()"></i>
          <i v-else class="fa fa-times icon-close-sidenav-main cursor-pointer p-3" aria-hidden="true" @click="toggleSidebar()"></i>
        </div>
      </div>
    </div>
    <hr class="horizontal light mt-0 mb-2" />
    <sidenav-list />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-ct.png";
import logoDark from "@/assets/img/logo-ct-dark.png";
import { mapMutations, mapState } from "vuex";
import TokenService from "../../services/token.service";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
      logoDark,
      token: TokenService.getLocalAccessToken()
    };
  },
  computed: {
    ...mapState(["isRTL", "sidebarType", "isDarkMode", "isCollapsed"]),
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator", "toggleCollapse"]),
    toggleSidebar() {
      if (window.innerWidth < 1200) {
        this.navbarMinimize();
      } else {
        this.toggleCollapse();
      }
    }
  }
};
</script>
<style scoped>
  .logo-text {
    font-weight: bold;
    font-size: 30px;
    color: #ffffff;
  }

  .sidenav.collapsed .logo-text {
    font-size: 20px;
  }

  .navbar-vertical.navbar-expand-xs.collapsed {
    width: max-content;
  }
</style>
